import { defineComponent } from 'vue'

import FetchGroupInformationDetails from '~/apollo/queries/group/fetchGroupDetail.gql'

import type { ApolloQueryResult } from 'apollo-client'
import { type FetchGroupInformationQuery } from '~/types/types'

export type GroupDetailQueryT = NonNullable<
  ApolloQueryResult<FetchGroupInformationQuery>['data']['repositoryGroup']
>

export default defineComponent({
  name: 'GroupDetailMixin',
  data() {
    return {
      group: null as null | GroupDetailQueryT
    }
  },
  methods: {
    async fetchGroupInformation(groupSlug: string, refetch = false): Promise<void> {
      try {
        const response: ApolloQueryResult<FetchGroupInformationQuery> =
          await this.$fetchGraphqlData(
            FetchGroupInformationDetails,
            {
              groupSlug
            },
            refetch
          )

        if (response.data.repositoryGroup) {
          this.group = response.data.repositoryGroup
        }
      } catch (error) {
        this.$logErrorAndToast(
          error as Error,
          'An error occurred while fetching group information.'
        )
      }
    }
  }
})
